import { Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Tooltip } from 'framework/ui/mui-builder';
import { useUiTheme } from 'framework/uiTheme';
import { BaseFieldLayoutType, FieldProps, useFieldHelper } from 'framework/ui/field';
import { getLabel } from 'framework/utils';
import {
  POSITION_SLOT_WORKER_TYPE,
  POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP,
  POSITION_SLOT_WORKER_TYPE_LABELS,
} from '../constants';
import { PositionSlotWorkerType } from '../types';

const PositionSlotCategoryField = ({
  source = 'workerType',
  label,
  isSortable,
  className,
  isColumnDirection,
}: FieldProps) => {
  const { getValue } = useFieldHelper<PositionSlotWorkerType>({ source });
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();
  const workerType = getValue();
  const categoryLabel = workerType ? POSITION_SLOT_WORKER_TYPE_LABELS[workerType] || workerType : '';

  const value =
    workerType === POSITION_SLOT_WORKER_TYPE.EXCEPTION ? (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        <span>{categoryLabel}</span>
        <Tooltip title={POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP}>
          <WarningAmberIcon sx={{ fontSize: 18, color: 'warning.main', verticalAlign: 'middle' }} />
        </Tooltip>
      </Box>
    ) : (
      categoryLabel
    );

  return (
    <BaseFieldLayout
      isColumnDirection={isColumnDirection}
      label={getLabel(label, source)}
      value={value}
      isSortable={isSortable}
      className={className}
    />
  );
};

export default PositionSlotCategoryField;
